import Box from "./Box";
import Icon from "./Icon";

export default function Token({ value, size = 16 }: { value: number, size?: number }) {
	return (
		<Box gap={0.5}>
			<Icon.Coin size={size} />
			{value}
		</Box>
	);
}